import { merge } from '@ta/utils';

import { baseEnvironment } from './environment.base';

export const environment = merge()<typeof baseEnvironment>(baseEnvironment, {
  development: true,
  version: '0.0.1-dev',

  DEBUG: true,
  DEBUG_LEVEL: 2,

  GRAPHQL_SERVER_CONFIG: {
    url: 'https://local-api.bailo.be/graphql',
  },
  REST_SERVER_CONFIG: {
    pendindRequestId: 5,
    serverUrl: 'https://local-api.bailo.be/api',
  },
  STRAPI_SERVER_CONFIG: {
    url: 'http://localhost:1338/graphql',
    // TODO: SECURITY - Inject via CI/CD environment variables
    token:
      '3f91872e0c347cbf74aa9183cd4e1a397aa946847695bc83784da7fa49c5d0a90444bf5ab4821ea222c253884d4c6636ffc56aad7e5d8eb8768014f6618722b6e6c30e3fc0aac40fad5c41d361919d3302fd8aea20744e7f9facc9257e986cb775754550594587bfc3f90189dceb92c2c4a48ce2a75d42f306dd2a337f90de83',
  },

  PWA: {
    active: true,
  },

  AUTH0: {
    domain: 'auth.bailo.be',
    // TODO: SECURITY - Inject via CI/CD environment variables
    clientId: '395ROGYK9aHj4MnUMtRDscY4icWlpsnj',
    cacheLocation: 'localstorage',
    authorizationParams: {
      audience:
        'https://bailoapi-app-20250826203204.calmgrass-23d7e508.francecentral.azurecontainerapps.io/',
      redirect_uri: window.location.origin,
    },
    httpInterceptor: {
      allowedList: [
        {
          uri: 'https://local-api.bailo.be/*',
          // TODO: SECURITY - should be false in production
          allowAnonymous: true,
        },
      ],
    },
  },
});
